
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapide-club",
      function () {
        return require("private-next-pages/rapide-club/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapide-club"])
      });
    }
  